import { CommonEnums } from '../common.enums';

export class FldrObjectUtil {
    private static instance: FldrObjectUtil;

    static getInstance() {
        if (!FldrObjectUtil.instance) {
            FldrObjectUtil.instance = new FldrObjectUtil();
        }

        return FldrObjectUtil.instance;
    }

    /**
    * FldrObjectUtil is a singleton class, so use FldrObjectUtil.getInstance() method instead of creating new FldrObjectUtil().
    */
    private constructor() {
    }


    getObj_Cd(object: any): string {
        if (object.hasOwnProperty('dxMp')) {
            return CommonEnums.codes.DESIGN;
        }

        if (object.hasOwnProperty('conn')) {
            return CommonEnums.codes.REPCONN;
        }

        if (object.hasOwnProperty('dObj')) {
            return CommonEnums.codes.DATAOBJECT;
        }

        if (object.hasOwnProperty('dxFlow')) {
            return CommonEnums.codes.STREAM;
        }

        if (object.hasOwnProperty('native_Db_Seq')) {
            return CommonEnums.codes.DBSEQ;
        }

        if (object.hasOwnProperty('dxFun')) {
            return CommonEnums.codes.DBFUN;
        }

        if (object.hasOwnProperty('usr_Def_Fun')) {
            return CommonEnums.codes.UDF;
        }
    }

    
    getObj_Id(object: any): number {
        if (object.hasOwnProperty('dxMp')) {
            return object.dxMp.dxMp_Id;
        }

        if (object.hasOwnProperty('conn')) {
            return object.conn.conn_Id;
        }

        if (object.hasOwnProperty('dObj')) {
            return object.dObj.dObj_Id;
        }

        if (object.hasOwnProperty('dxFlow')) {
            return object.dxFlow.dxFlow_Id;
        }

        if (object.hasOwnProperty('native_Db_Seq')) {
            return object.native_Db_Seq.native_Db_Seq_Id;
        }

        if (object.hasOwnProperty('dxFun')) {
            return object.dxFun.dxFun_Id;
        }

        if (object.hasOwnProperty('usr_Def_Fun')) {
            return object.usr_Def_Fun.udf_Id;
        }
    }

}